import React from 'react';
import styled from '@emotion/styled';

const BorderLine = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  background-color: ${props => props.color};
  margin-bottom: 10px;
`;

export default ({ color }) => <BorderLine className="border-line" color={color} />;
